import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { StringUtils } from '../../utils';
import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions, ConsultationsActions, ToastActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar } from  '../../components'

class ConsultationReassignScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  componentDidMount() {
    this.props.practiceActions.getPracticeStaff(this.props.user.auth.token, this.props.context.selectedPractice);
  }

  renderReassignSection = (consultation, staff) => {
    if (!consultation || !staff) {
      return null;
    }

    let location_id       = consultation.location_id;
    let practiceLocations = this.props.practice && this.props.practice.locations ? this.props.practice.locations : {};
    let location          = practiceLocations[location_id] || null;
    let location_name     = location && location.name ? location.name : '';
    let location_prvdrs   = this.props.practice && this.props.practice.providerLocations && this.props.practice.providerLocations[location_id] ? this.props.practice.providerLocations[location_id] : {};

    let practice    = this.props.practice && this.props.practice.info ? this.props.practice.info : null;
    let title       = practice && practice.type === 'MEDICAL' ? 'Veterinarians at this location' : 'Providers at this location';
    let success_msg = consultation.primary_assignee === 'unassigned' ? 'Provider assigned to consultation' : 'Consultation Reassigned';

    const staffRows = staff.map((member) => {
      const userInfo = member.user_details && member.user_details[0] ? member.user_details[0] : member.user_details[0];
      if (userInfo && member.user_id !== consultation.primary_assignee && (member.vet === true || member.behaviorist === true) && location_prvdrs[member.user_id]) {
        return <div key={member._id} className="flex-container flex-container-row flex-space-between flex-center-align" style={{ marginTop: 5, marginBottom: 5 }}>
          <span>{ StringUtils.displayName(userInfo) }</span>
          <input  type="submit"
                  value="Assign"
                  className="button-default"
                  style={{ paddingTop: 5, paddingBottom: 5 }}
                  onClick={ () => {
                    var consultationObjectUpdates = {
                      primary_assignee: member.user_id,
                      _id: consultation._id,
                      practice_id: consultation.practice_id,
                    }
                    this.props.consultationsActions.updateConsultation(this.props.user.auth.token, consultationObjectUpdates, () => { this.successAction(success_msg) })
                  }}
                />
        </div>
      }
    }).filter((memberRow) => { return memberRow });

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        <div className="basic-container">
        <div className='flex-container-column'>
          <h5>{ title }</h5>
          <div style={{ fontSize: 15, color: '#1dc2ff', marginTop: -10 }}>{ location_name }</div>
        </div>

        { staffRows }

        </div>
      </div>
    </div>
  }

  render() {

    const selectedConsultation = this.props.consultations && this.props.consultations.selectedConsultation ? this.props.consultations.selectedConsultation : {};
    var consultation =  this.props.consultations
                          && this.props.consultations.allConsultations
                          && this.props.consultations.allConsultations[selectedConsultation._id] ? this.props.consultations.allConsultations[selectedConsultation._id] : selectedConsultation;

    const staff      = this.props.practice.staff || null;
    let screen_title = consultation && consultation.primary_assignee === 'unassigned' ? 'Assign a provider' : 'Reassign consultation to another provider';
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title={screen_title} />
        { this.renderReassignSection(consultation, staff) }
      </div>
    );
  }

  successAction = (success_msg) => {
    this.props.toastActions.displayInfo(success_msg);
    NavigationActions.navigateBack();
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
    consultations: state.consultations,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    consultationsActions: bindActionCreators(
     { ...ConsultationsActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    toastActions: bindActionCreators(
     { ...ToastActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultationReassignScreen)
